export const INVOICE_NUMBER_MAX_VALUE = 999_999_999.99;
